import React from "react";
import { RelatedPosts } from "../../components/Blog";
import { PostContent } from "../../components/Blog/PostContent";
import { HeroPost, Author } from "../../components/Post";
import { Layout } from "../../layout";
import { NotFound } from "../../components"
import { PostType, TagType } from "../../types";
import { hubspot } from "../../services";

function Post({ location, serverData }: any) {
	const { post, author, tag, relatedPosts } = serverData || {}

	return (
		<Layout
			location={location}
			title={post?.htmlTitle}
			description={post?.metaDescription}
			article
			image={post?.featuredImage}
			useCustomUrl
			hiddeSuperscript
			showDivider
		>
			{
				(!post && !author) ? (
					<NotFound />
				) : (
					<>
						<HeroPost post={post} tag={tag} />
						<PostContent post={post} />
						<Author post={post} />
						<RelatedPosts
							posts={relatedPosts?.results || []}
							tags={Array<TagType>(tag)}
						/>
					</>
				)
			}
		</Layout>
	)
}

export async function getServerData(context: any) {
	const data = await hubspot.get(`posts?slug__eq=${context.params.id}`)

	if (data?.total === 0) return {
		status: 404,
		props: {
			post: null,
			author: null,
		},
	}

	const post: PostType = data?.results[0] || {}
	const postTagId = post?.tagIds ? post.tagIds[0] : 0

	const [author, tag, relatedPosts] = await Promise.all([
		hubspot.get(`authors/${post?.blogAuthorId}`),
		hubspot.get(`tags/${postTagId}`),
		hubspot.get(`posts?tagId__eq=${postTagId}`)
	])

	return {
		props: {
			post: post || {},
			author: author || {},
			tag: tag || {},
			relatedPosts: relatedPosts
		},
	}
}


export default Post